import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from '../../helper/className';
import { userOrganisationInfoShape } from '../../shapes/userOrganisationInfoShape';
import { withOrganisationLogo } from '../../decorators/withOrganisationLogo';
import Image from '../Image/Image';

export class OrganisationLogoBlockComponent extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    organisationInfo: userOrganisationInfoShape
  };

  static className = 'esk-organisation-logo-block';
  static getClassName = getClassNameGenerator(OrganisationLogoBlockComponent.className);

  render() {
    const { className, organisationInfo } = this.props;
    if (!organisationInfo) {
      return null;
    }

    return (
      <figure className={classNames(OrganisationLogoBlock.className, className)}>

        <div  className={OrganisationLogoBlock.getClassName('image-container', true)}>
          <Image
            className={OrganisationLogoBlock.getClassName('image', true)}
            src={organisationInfo.organisationLogoUrl}
            alt={organisationInfo.organisationName}
          />
        </div>

        <figcaption className={OrganisationLogoBlock.getClassName('title', true)}>
          {organisationInfo.organisationName}
        </figcaption>

      </figure>
    );
  }

}

export const OrganisationLogoBlock = withOrganisationLogo(OrganisationLogoBlockComponent);

